module.exports = __webpack_public_path__ + "static/media/leftArrowIcon.d0b094f3.svg";